import { ConfirmationmailRepository } from "../repositories/Confirmation.repository";

export const ConfirmationmailService = {
   sendMailConfirmation
};

function sendMailConfirmation(email){
   return ConfirmationmailRepository.sendMailConfirmation(email);
}
